// extracted by mini-css-extract-plugin
module.exports = {"overlay":"QRCodeModal_overlay__j12Kb","modal":"QRCodeModal_modal__3Y2n3","content":"QRCodeModal_content__0AcDg","qrContainer":"QRCodeModal_qrContainer__EnlyK"};